import { render } from "./NotificationsList.vue?vue&type=template&id=6a0cf34e&scoped=true"
import script from "./NotificationsList.vue?vue&type=script&lang=ts"
export * from "./NotificationsList.vue?vue&type=script&lang=ts"

import "./NotificationsList.vue?vue&type=style&index=0&id=6a0cf34e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a0cf34e"

export default script